export default __webpack_public_path__ + "static/media/IMG_2002.3301fb93.JPG";